module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(!_vm.file.id) ? _c('div', [_c('label', {
    attrs: {
      "for": "attachments"
    }
  }, [_vm._v("Загрузите шаблон квитанции")]), _vm._v(" "), _c('div', {
    staticClass: "drag-n-drop"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "attachments",
      "name": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-upload"
  }), _vm._v(" перетащите файл сюда или кликните\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.file.id) ? _c('ul', {
    staticClass: "files-list"
  }, [_c('li', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('a', {
    attrs: {
      "href": _vm.file.file,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.file.file))])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e1e59b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/bill_template/fields/Attachments.vue
// module id = 594
// module chunks = 0